import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Keys, StorageService} from '../../service/storage.service';
import {Injectable} from '@angular/core';
import {ChannelPartnerService} from '../../service/channel-partner.service';

@Injectable()
export class ChannelPartnerLogoResolver implements Resolve<string> {
    private storageService: StorageService;
    private channelPartnerService: ChannelPartnerService;

    constructor(storageService: StorageService, channelPartnerService: ChannelPartnerService) {
        this.storageService = storageService;
        this.channelPartnerService = channelPartnerService;
    }

    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<string> {
        const partnerId = route.queryParams['channel-partner-id'];
        const partnerLogo = this.storageService.getItem(Keys.PARTNER_LOGO);

        if (partnerLogo) {
            return partnerLogo;
        } else if (partnerId) {
            try {
                const channelPartner = await this.channelPartnerService.getPartnerDetails(partnerId);
                this.storageService.saveItem(Keys.PARTNER_LOGO, channelPartner.partnerMedia.logo);
                return channelPartner.partnerMedia.logo;
            } catch (e) {
            }
        }
        return null;
    }
}
